module.exports = __webpack_public_path__ + "img/16l006-02.01e4b84a.png";